import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { checklistsApi } from 'src/Services/API';

const useFetchChecklists = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-checklists', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await checklistsApi.checklistsControllerFindAll(assetId)).data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchChecklists;
